import { createClient } from '@supabase/supabase-js'

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY

// Debug logging to check if environment variables are loaded
console.log('Supabase URL:', supabaseUrl ? 'Loaded' : 'NOT LOADED')
console.log('Supabase Anon Key:', supabaseAnonKey ? 'Loaded' : 'NOT LOADED')

export const supabase = createClient(supabaseUrl, supabaseAnonKey)
